import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class BlockchainService { 

    constructor(private http: HttpClient) { }

    getblockchainService() {
        return this.http.get<any[]>(`${environment.apiUrl}get_blockchain_details`);
    }    	    
}
